export const isUrl = (url: string): boolean => {
  const protocolAndDomainPattern = /^(?:https?:\/\/)(\S+)$/;
  const nonLocalhostDomainPattern = /^[^\s\.]+\.\S{2,}$/;

  if (typeof url !== "string") {
    return false;
  }

  var match = url.match(protocolAndDomainPattern);
  if (!match) {
    return false;
  }

  var everythingAfterProtocol = match[1];
  if (!everythingAfterProtocol) {
    return false;
  }

  if (nonLocalhostDomainPattern.test(everythingAfterProtocol)) {
    return true;
  }

  return false;
};

export const getCurrentUrl = () => {
  let currentUrl = window.location.href;
  const lastLocationChar = currentUrl[currentUrl.length - 1];

  if (lastLocationChar === '/') {
    currentUrl = currentUrl.slice(0, -1);
  }

  return currentUrl;
};
